import classNames from "classnames"
import React from "react"

const Checkbox = ({
  name,
  label,
  register,
  value,
  onChange,
  onClick,
  variant = "primary",
  error,
  disabled = false,
  small = false,
}) => {
  if (!register) {
    return (
      <div>
        <label
          className={classNames("checkbox", {
            "checkbox--primary": variant === "primary",
            "checkbox--secondary": variant === "secondary",
            "checkbox--tertiary": variant === "tertiary",
            "checkbox--disabled": disabled,
          })}
          onClick={disabled ? undefined : onClick}
        >
          <input
            name={name}
            type="checkbox"
            className="checkbox__input"
            checked={value}
            onChange={disabled ? undefined : onChange} 
            disabled={disabled}
          />
          {value ? selectedSvg(variant, disabled) : unSelectedSvg(variant, disabled)} 
          {label && (
            <span
              className={classNames(`checkbox__label${value ? " checked" : ""}`, {
                "checkbox__label--small": small,
                disabled: disabled,
              })}
            >
              {label}
            </span>
          )}
        </label>
        {error && <p className="signup-input__error-message">{error}</p>}
      </div>
    )
  }

  return (
    <div>
      <label
        className={classNames("checkbox", {
          "checkbox--primary": variant === "primary",
          "checkbox--secondary": variant === "secondary",
          "checkbox--tertiary": variant === "tertiary",
          "checkbox--disabled": disabled,
        })}
      >
        <input
          name={name}
          type="checkbox"
          className="checkbox__input"
          {...register}
          disabled={disabled}
        />
        {value ? selectedSvg(variant, disabled) : unSelectedSvg(variant, disabled)}
        <span
          className={classNames("checkbox__label", {
            "checkbox__label--small": small,
            disabled: disabled,
          })}
        >
          {label}
        </span>
      </label>
      {error && <p className="signup-input__error-message">{error}</p>}
    </div>
  )
}

const selectedSvg = (variant, disabled) => (
  <svg
    width="33"
    height="34"
    viewBox="0 0 33 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames({ disabled: disabled })}
  >
    <rect
      x="3"
      y="3.23926"
      width="27"
      height="27"
      rx={variant === "primary" ? "6" : "2"}
      fill={variant === "tertiary" ? "none" : disabled ? "#D1CFCF" : "currentColor"}
      stroke={variant === "tertiary" ? "#fff" : disabled ? "#D1CFCF" : "currentColor"}
      strokeWidth={variant === "primary" ? "6" : "2"}
    />
    <path
      d="M15.76 22.331L21.344 12.6592L19.2378 11.4432L14.7338 19.2443L11.048 17.1163L9.96802 18.987L15.76 22.331Z"
      fill={disabled ? "#E0E0E0" : "white"}
    />
  </svg>
)

const unSelectedSvg = (variant, disabled) => (
  <svg
    width="33"
    height="34"
    viewBox="0 0 33 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames({ disabled: disabled })}
  >
    <rect
      x="3"
      y="3.23926"
      width="27"
      height="27"
      rx={variant === "primary" ? "6" : "2"}
      fill={variant === "tertiary" ? "none" : "white"}
      stroke={
        disabled
          ? "#D1CFCF"
          : variant === "primary"
          ? "currentColor"
          : variant === "tertiary"
          ? "#fff"
          : "#D1CFCF"
      }
      strokeWidth={variant === "primary" ? "6" : "2"}
    />
  </svg>
)

export default Checkbox